function getContextWindow({ current }) {
  return current ? current.ownerDocument.defaultView : null;
}
export {
  getContextWindow
};
